<script setup>
import { useHead, useScrollTopOnMounted, useRoute } from '#imports';
import { getCommonMetaTags } from '~/utils/get-common-meta-tags';
import ActHeaderCard from '~/components/act-header-card.vue';

useScrollTopOnMounted();

const route = useRoute();

const title = 'Поддержать DOXA — Действуйте!';
const description =
  'Мы работаем только с вашей помощью и только в интересах наших читатель:ниц — поддержите DOXA, подпишитесь на ежемесячный или разовый донат!';

useHead({
  title,
  meta: getCommonMetaTags({
    path: route.fullPath,
    ogType: 'website',
    title,
    description,
    ogImageUrl:
      'https://cdn.sanity.io/images/86svaih1/production/868db5536251639ee012cc1f4907cf344f8031e1-1200x630.png',
  }),
});
</script>

<template>
  <LayoutDefaultPage
    is-animated-header
    is-header-shown
    is-hide-donation-form
    is-transparent-header
  >
    <div class="act">
      <ActHeaderCard />
      <div class="act__container content-container">
        <div class="act__text">
          <p>
            DOXA рассказывает о главных вызовах, которые стоят перед нами
            сейчас, — о войне, репрессиях и диктатуре, о климатическом кризисе и
            катастрофическом уровне неравенства.
          </p>
          <p>
            Мы честно и подробно разбираем эти проблемы, чтобы вы могли
            ориентироваться в информации и действовать. Мы говорим о том, как
            можно сопротивляться, и каким мог бы быть более справедливый,
            безопасный и интересный мир.
          </p>
          <p>
            Мы очень благодарны тем, кто нам помогает. Нам нужна ваша поддержка,
            чтобы мы могли разбираться в новостях и сообщать о них оперативно и
            понятно. Чтобы наши автор:ки и редактор:ки могли глубоко погружаться
            в тексты и описывать сложные вещи простым языком. Чтобы наши
            материалы были красиво проиллюстрированы, смонтированы и свёрстаны и
            становились более полезны нам с вами.
          </p>

          <div class="act__acknowledgement-wrapper">
            <div class="act__acknowledgement">
              <div class="act__acknowledgement-heart" />
              <span> Спасибо, что верите в нас! </span>
            </div>
            <div class="act__acknowledgement-divider" />
          </div>

          <p>
            Вы всегда можете изменить способ оплаты или размер ежемесячного
            платежа, а также отменить свою подписку.
            <br />
            Для этого напишите нам на
            <BaseExternalLink href="mailto:act@doxa.team">
              act@doxa.team
            </BaseExternalLink>
          </p>
        </div>
        <div class="act__links">
          <AboutCard />
        </div>
      </div>
    </div>
  </LayoutDefaultPage>
</template>

<style lang="postcss" scoped>
.act {
  display: flex;
  flex-direction: column;

  &__container {
    display: flex;
    justify-content: space-between;
    padding: 60px 60px 120px;
    gap: 30px;
  }

  &__text {
    font-size: var(--body-font-size);
    line-height: var(--body-line-height);
    font-family: var(--body-font-family);
    display: flex;
    flex-direction: column;
    gap: 32px;
  }

  &__acknowledgement {
    display: flex;
    align-items: center;
    gap: 16px;
  }

  &__acknowledgement-wrapper {
    display: flex;
    flex-direction: column;
    gap: 16px;
  }

  &__acknowledgement-heart {
    width: 56px;
    height: 68px;
    background-image: url('/images/heart.png');
    background-repeat: no-repeat;
    background-position: center;
    background-size: contain;
  }

  &__acknowledgement-divider {
    width: 100%;
    height: 2px;
    opacity: 0.2;
    background: linear-gradient(
      90deg,
      rgba(0, 0, 0, 20%) 0%,
      rgba(0, 0, 0, 100%) 50%,
      rgba(0, 0, 0, 20%) 100%
    );
  }

  &__links {
    min-width: 422px;

    @media (--tablet-vp) {
      min-width: auto;
    }
  }

  @media (min-resolution: 192dpi) {
    &__acknowledgement-heart {
      background-image: url('/images/heart@2x.png');
    }
  }

  @media (--small-vp) {
    &__container {
      flex-direction: column;
      padding: 60px 12px 60px;
      gap: 52px;
    }

    &__text {
      font-size: 16px;
      line-height: 22px;
    }

    &__acknowledgement-heart {
      width: 40px;
      height: 44px;
    }

    &__links {
      min-width: auto;
    }
  }
}
</style>
